// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-534831f3]{background-color:#5b6fa8;border-radius:8px;color:#fff;display:inline-block;font-family:Outfit,sans-serif;font-size:16px;font-weight:600;padding:14px 28px;text-decoration:none;transition:filter .2s ease,transform .15s ease;white-space:nowrap}.btn[data-v-534831f3]:hover{filter:brightness(.85);transform:translateY(-1px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
